import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

/**
 * Renew filebox records request DTO
 */
export class RenewFileboxRecordsRequest {
	leasedBy!: string;
	@TransformDate()
	leasedUntil!: Date;
	@TransformInt()
	ids!: number[];
}
